"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcTicksForSchedule = void 0;
// Now, calculate all ticks that take place between our from and to dates
const later_1 = __importDefault(require("@breejs/later"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Cron_1 = __importDefault(require("../Cron"));
const CronField_1 = __importDefault(require("../Cron/CronField"));
const CustomRepetitionType_1 = __importDefault(require("../CustomRepetitionType"));
const RepetitionType_1 = __importDefault(require("../RepetitionType"));
const MAX_NO_OF_TICKS = 1000;
function calcTicksForSchedule(from, // SHOULD BE UTCIFIED DATE
to, // SHOULD BE UTCIFIED DATE
schedule) {
    let ticks;
    if (!schedule.repetitionType || !schedule.dueDate)
        return [];
    if (schedule.repetitionType === RepetitionType_1.default.NEVER) {
        if ((0, moment_timezone_1.default)(schedule.dueDate).isBetween(from, to))
            ticks = [schedule.dueDate];
    }
    else {
        let cron = scheduleToCron(schedule.dueDate, schedule.repetitionType, schedule.customRepetition);
        ticks = later_1.default.schedule(later_1.default.parse.cron(cron)).next(MAX_NO_OF_TICKS, from, to);
    }
    return !!ticks ? ticks.map(d => (0, moment_timezone_1.default)(d).seconds(0).milliseconds(0).toDate()) : [];
}
exports.calcTicksForSchedule = calcTicksForSchedule;
exports.default = calcTicksForSchedule;
function scheduleToCron(dueDate, repetitionType, customRepetition) {
    const cron = new Cron_1.default();
    const utcDue = (0, moment_timezone_1.default)(dueDate).tz('utc');
    cron.hour = new CronField_1.default().fromString(String(utcDue.hours()));
    cron.minute = new CronField_1.default().fromString(String(utcDue.minutes()));
    switch (repetitionType) {
        case RepetitionType_1.default.NEVER: {
            cron.hour = new CronField_1.default();
            cron.minute = new CronField_1.default();
            break;
        }
        case RepetitionType_1.default.DAILY: {
            cron.dayOfWeek = new CronField_1.default().base(0).fromBoolFnc(7, () => true);
            break;
        }
        case RepetitionType_1.default.WEEKLY: {
            const weekday = calcDayOfWeek(utcDue);
            cron.dayOfWeek = new CronField_1.default().base(0).fromBoolFnc(7, i => i === weekday - 1);
            break;
        }
        case RepetitionType_1.default.MONTHLY: {
            const weekOfMonth = calcWeekOfMonth(utcDue);
            const weekday = calcDayOfWeek(utcDue);
            cron.dayOfMonth =
                weekOfMonth < 0
                    ? new CronField_1.default().fromString(`${weekday}L`)
                    : new CronField_1.default().fromString(`${weekday}#${weekOfMonth}`);
            break;
        }
        case RepetitionType_1.default.MONTHLY_BY_DATE: {
            const dom = utcDue.date() - 1;
            cron.dayOfMonth = new CronField_1.default().fromBoolFnc(31, i => i === dom);
            break;
        }
        case RepetitionType_1.default.ANNUALLY: {
            const weekOfMonth = calcWeekOfMonth(utcDue);
            const weekday = calcDayOfWeek(utcDue);
            const month = utcDue.month();
            cron.dayOfMonth =
                weekOfMonth < 0
                    ? new CronField_1.default().fromString(`${weekday}L`)
                    : new CronField_1.default().base(0).fromString(`${weekday}#${weekOfMonth}`);
            cron.month = new CronField_1.default().fromBoolFnc(12, i => i === month);
            break;
        }
        case RepetitionType_1.default.ANNUALLY_BY_DATE: {
            const dom = utcDue.date() - 1;
            const month = utcDue.month();
            cron.dayOfMonth = new CronField_1.default().fromBoolFnc(31, i => i === dom);
            cron.month = new CronField_1.default().fromBoolFnc(12, i => i === month);
            break;
        }
        case RepetitionType_1.default.CUSTOM: {
            processCustom(customRepetition, cron);
            break;
        }
    }
    return cron.toString();
}
function processCustom(cRep, cron) {
    switch (cRep.customRepetitionType) {
        case CustomRepetitionType_1.default.WEEKLY: {
            cron.dayOfWeek = new CronField_1.default().base(0).fromBoolFnc(7, foundIn(cRep.weekdays, 0));
            break;
        }
        case CustomRepetitionType_1.default.MONTHLY: {
            let weekday = offsetDayByOne(cRep.weekdays[0]);
            const weekOfMonth = cRep.weeksOfMonth[0];
            cron.dayOfMonth =
                weekOfMonth < 0
                    ? new CronField_1.default().fromString(`${weekday}L`)
                    : new CronField_1.default().fromString(`${weekday}#${weekOfMonth}`);
            break;
        }
        case CustomRepetitionType_1.default.MONTHLY_BY_DATE: {
            cron.dayOfMonth = cRep.last
                ? new CronField_1.default().fromString('L')
                : new CronField_1.default().fromBoolFnc(31, foundIn(cRep.datesOfMonth));
            break;
        }
        case CustomRepetitionType_1.default.YEARLY: {
            const weekday = offsetDayByOne(cRep.weekdays[0]);
            const weekOfMonth = cRep.weeksOfMonth[0];
            cron.dayOfMonth =
                weekOfMonth < 0
                    ? new CronField_1.default().fromString(`${weekday}L`)
                    : new CronField_1.default().fromString(`${weekday}#${weekOfMonth}`);
            cron.month = new CronField_1.default().fromBoolFnc(12, foundIn(cRep.monthsOfYear));
            break;
        }
        case CustomRepetitionType_1.default.YEARLY_BY_DATE: {
            cron.dayOfMonth = cRep.last
                ? new CronField_1.default().fromString('L')
                : new CronField_1.default().fromBoolFnc(31, foundIn(cRep.datesOfMonth));
            cron.month = new CronField_1.default().fromBoolFnc(12, foundIn(cRep.monthsOfYear));
            break;
        }
    }
}
function foundIn(arr, base = 1) {
    return i => arr.indexOf(i + base) >= 0;
}
function calcWeekOfMonth(m) {
    const wom = Math.ceil(m.date() / 7);
    if (wom === 5)
        return -1;
    return wom;
}
function calcDayOfWeek(m) {
    return offsetDayByOne(m.isoWeekday());
}
function offsetDayByOne(n) {
    let r = n + 1;
    if (r > 7)
        r -= 7;
    return r;
}
